import { Card } from 'antd';
import { Text } from '../Text';
import PlaceHolderImage from './assets/placeholder-image.png';
import styled from 'styled-components';

interface CardInfoProps{
    imageUrl?: string;
    title: string;
    subTitle?: string;
    className?: string;
    onClick?: () => void;
}

const StyledCard = styled(Card)`
    width: 100%;
    cursor: pointer;
    border-radius: 16px;

    .ant-card-body {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      border-radius: 16px;
      border: none;
    }
    
    .ant-card-body::before, .ant-card-body::after {
      display: none;
    }

    .fzt-image {
      width: 100%;
      height: auto;
      border-radius: 16px;
      object-fit: cover;

      &.fzt-border {
        border: 1px solid #E4E4E4;
    }
  }
`;

const CardInfo: React.FC<CardInfoProps> = ({ imageUrl, title, subTitle, className, onClick }) => {
  return (
    <StyledCard className={className} onClick={onClick}>
      <img className={`fzt-image ${!imageUrl ? 'fzt-border' : ''}`} src={imageUrl || PlaceHolderImage} alt={title} />
      <div>
         <Text title_h5 semibold caplock left color='neutral.text.5'>{title}</Text>
         <Text content_1 regular left color='neutral.text.4'>{subTitle}</Text>
       </div>
    </StyledCard>
  );
};

export default CardInfo;